<template>
  <div class="base-select" :class="modifierClassnames">
    <template v-if="label">
      <label :for="id" class="base-select__label">
        {{ label }}
      </label>
    </template>
    <div class="base-select__select-wrapper">
      <span class="caret"></span>
      <select v-model="model" :id="id" :name="name">
        <option v-if="!hideEmptyOption" :value="undefined" selected class="base-select__option --placeholder">
          {{ emptyOptionLabel }}
        </option>
        <option v-for="option in options" :value="option.value" :key="option.value" class="base-select__option">
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: String,
    default: undefined,
  },
  id: {
    type: String,
    default: undefined,
  },
  name: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    default: undefined,
  },
  options: {
    type: Array,
    required: true,
  },
  hideEmptyOption: {
    type: Boolean,
    default: false,
  },
  emptyOptionLabel: {
    type: String,
    default: "Choose one",
  },
});

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const modifierClassnames = computed(() => ({
  "--has-value": model.value,
}));
</script>

<style lang="scss" scoped>
.base-select {
  --caret-size: var(--sp-dtv-select-caret-size, 0.75rem);
  --color: var(--sp-dtv-select-color, var(--sp-sys-color-on-surface, #333));
  --placeholder-color: var(--sp-dtv-select-placeholder-color, var(--sp-sys-form-field-placholder-color, #ddd));
  --caret-right-offset: var(--sp-dtv-select-padding-inline, 1rem);
}

.base-select__select-wrapper {
  position: relative;
  select {
    box-shadow: var(--sp-dtv-select-box-shadow, none);
    position: relative;
    width: var(--sp-dtv-select-width, 100%);
    border: var(--sp-dtv-select-border, var(--sp-sys-form-field-border, 1px solid #ccc));
    appearance: none;
    -webkit-appearance: none;
    min-height: var(--sp-dtv-select-min-height, 3rem);
    padding: var(--sp-dtv-select-padding-block, 0) var(--sp-dtv-select-padding-inline, 1rem);
    font-size: var(--sp-dtv-select-font-size, var(--sp-sys-form-field-font-size, 1rem));
    border-radius: var(--sp-dtv-select-border-radius, var(--sp-sys-form-field-border-radius, 0));
    color: var(--color);
    cursor: pointer;
    background-color: transparent;
  }
  .caret {
    position: absolute;
    top: 50%;
    right: var(--caret-right-offset);
    transform: translateY(-75%) rotate(45deg);
    width: var(--caret-size);
    height: var(--caret-size);

    border-bottom: var(--sp-dtv-select-caret-border, var(--sp-sys-form-field-border, 1px solid #ccc));
    border-right: var(--sp-dtv-select-caret-border, var(--sp-sys-form-field-border, 1px solid #ccc));
  }
}
</style>
